import { Payload, payloadSchema } from 'embedded/api/in/messages/Payload';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { JSONSchemaType } from 'ajv';

export interface SetPortfolioMessagePayload extends Payload {
    orderIds?: string[];
    positions: Array<{ symbol: string; side?: 'B' | 'S' | 'SS'; qty?: number }>;
    symbology?: SymbologyValues;
}

export const setPortfolioMessagePayloadSchema: JSONSchemaType<SetPortfolioMessagePayload> =
    {
        type: 'object',
        properties: {
            ...payloadSchema.properties,
            symbology: {
                type: 'string',
                enum: [
                    SymbologyValues.Instinet,
                    SymbologyValues.Bloomberg,
                    SymbologyValues.CUSIP,
                    SymbologyValues.Local,
                    SymbologyValues.SEDOL,
                ],
                nullable: true,
            },
            orderIds: {
                type: 'array',
                items: {
                    type: 'string',
                },
            },
            positions: {
                type: 'array',
                minItems: 1,
                items: {
                    type: 'object',
                    properties: {
                        symbol: { type: 'string', minLength: 1 },
                        side: { type: 'string', enum: ['B', 'S', 'SS'] },
                        qty: { type: 'number' },
                    },
                    required: ['symbol'],
                },
            },
        },
        required: ['positions'],
        additionalProperties: false,
    };
